import type { CommunityMember, Space } from "@circle-react/types";

export const POST_TYPE = "Post";
export const COMMENT_TYPE = "Comment";
export const CONNECT_CONNECTION_TYPE = "Connect::Connection";
export const CHAT_ROOM_MESSAGE_TYPE = "ChatRoomMessage";

export type FlaggedContentableType =
  | typeof POST_TYPE
  | typeof COMMENT_TYPE
  | typeof CONNECT_CONNECTION_TYPE
  | typeof CHAT_ROOM_MESSAGE_TYPE;

export interface ChatMessageContextItem {
  author?: CommunityMember;
  id?: number;
  sent_at?: string;
  tiptap_body?: object;
}

export interface FlaggedContentable {
  body_trix_content?: string;
  context_messages_after?: ChatMessageContextItem[];
  context_messages_before?: ChatMessageContextItem[];
  flagged_contents_count?: number;
  flagged_for_approval_at?: string;
  id?: number;
  initiator?: CommunityMember;
  is_embedded?: boolean;
  is_image_post?: boolean;
  note?: string;
  parent_comment_id?: number;
  parent_message_id?: number | null;
  post_id?: number;
  post_slug?: string;
  published_at?: string;
  recipient?: CommunityMember;
  removed_at?: string;
  sent_at?: string;
  slug?: string;
  space?: Space;
  space_id?: number;
  space_slug?: string;
  status?: string;
  tiptap_body?: object;
  title?: string;
  type: FlaggedContentableType;
}

export interface ContentSnapshot {
  note?: string;
}

export interface FlaggedContentReport {
  action_by_community_member_name?: string;
  action_reason_body?: string;
  author?: CommunityMember;
  content_modified_since_report?: boolean;
  content_snapshot: ContentSnapshot | null;
  flagged_contentable?: FlaggedContentable;
  id?: number;
  profanity_filter_matches?: string;
  reported_at?: string;
  reported_reason_body?: string;
  reported_reason_type?: string;
  reporter?: CommunityMember;
  reports_count?: number;
  status?: string;
}

export interface FlaggedBySummary {
  has_ai?: boolean;
  has_auto_flagged?: boolean;
  member_count?: number;
}

export interface ContactSnapshot {
  chat_room_message?: number;
  comment?: number;
  connect_connection?: number;
  post?: number;
}

export interface FlaggedContent extends FlaggedContentReport {
  author_is_flagged?: boolean;
  author_is_flagged_for_embedded_chat?: boolean;
  contact_snapshot?: ContactSnapshot;
  flagged_by_summary?: FlaggedBySummary;
  initiator_is_flagged_for_connect?: boolean;
  member_connection_reports_count?: number;
  reports?: FlaggedContentReport[];
}

export type FlaggedContentStatus = "rejected" | "approved" | "pending";
